import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { PrimeNGSeverity } from '../../../shared-module/shared/types/primeng-severity.type';
import { triggerStateLabelKey, triggerStateSeverity } from './job-admin-labels';

@Component({
  selector: 'app-trigger-state-badge',
  templateUrl: './trigger-state-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TriggerStateBadgeComponent {
  readonly state = input.required<string>();

  readonly labelKey = computed(() => triggerStateLabelKey(this.state()));
  readonly severity = computed<PrimeNGSeverity>(() => triggerStateSeverity(this.state()));
}
